import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";
import { gradientToBottom } from "utils/css-utils";

interface IStylesProps {
  topColor?: string;
  bottomColor?: string;
}

export default makeStyles<MuiTheme, IStylesProps>((theme: MuiTheme) => ({
  root: {
    height: 50,
    background: theme.palette.common.white,
    display: "flex",
    alignItems: "center"
  },
  leftBorder: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    width: 4,
    borderRadius: "4px 0 0 4px",
    backgroundImage: ({ topColor, bottomColor }) =>
      gradientToBottom(topColor, bottomColor, 5)
  },
  content: {
    paddingLeft: 12,
    paddingRight: 12,
    overflow: "hidden"
  },
  title: {
    fontSize: 14,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    color: theme.palette.text.hint,
    lineHeight: "normal"
  },
  value: {
    fontSize: 14,
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal"
  }
}));
